var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoCamera = function SvgIconNoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 46,
    fill: "#425267"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m68.446 34.414-8.412 3.034V34.06a2.06 2.06 0 0 0-2.06-2.06H24.06A2.06 2.06 0 0 0 22 34.06v23.88A2.06 2.06 0 0 0 24.059 60h33.928a2.06 2.06 0 0 0 2.06-2.06v-3.426l8.412 3.059c.745.265 1.541-.215 1.541-.935V35.362c-.025-.695-.821-1.2-1.554-.935v-.013Zm-19.63 16.838a1.778 1.778 0 0 1-1.25 3.034c-.454 0-.91-.177-1.25-.518l-5.242-5.246-5.242 5.246a1.769 1.769 0 0 1-2.502 0 1.779 1.779 0 0 1 0-2.516l5.243-5.246-5.242-5.246a1.779 1.779 0 0 1 2.513-2.515l5.242 5.246 5.242-5.246a1.779 1.779 0 0 1 2.514 2.516L43.6 46.005l5.242 5.246h-.025Z",
    fill: "#9DACC0"
  })));
};
export default SvgIconNoCamera;